import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { RolesQuery } from "../../../graphql/deliveryService/queries/roles";
import { RolesOutput } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface UseRolesQueryProps {
  skip?: boolean;
  dataAction: (data: RolesOutput) => void;
  errorAction?: () => void;
}

const useRolesQuery = (props: UseRolesQueryProps) => {
  const { t } = useTranslation();
  const { skip = false, dataAction, errorAction } = props;

  const query = useQuery(RolesQuery, {
    skip,
    fetchPolicy: "network-only",
  });

  const { data, error } = query;
  const rolesOutput = data?.roles;

  useEffect(() => {
    if (!error) return;

    handleError(t("rolesError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !rolesOutput) return;

    dataAction(rolesOutput);
  }, [data]);

  return query;
};

export default useRolesQuery;
